<script setup lang="ts">
import { type ReportTemplate } from "@/types";
import TemplateSettingsForm from "../../settings/TemplateSettingsForm.vue";

defineProps<{
  template: ReportTemplate;
}>();
</script>

<template>
  <TemplateSettingsForm :template-settings="template.settings" />
</template>

<style lang="scss" scoped></style>
